import { OptionItem } from "@transfr-inc/dashboard-components/forms";

export class CategoryOptionItem extends OptionItem {
  constructor(category) {
    const { categoryId, categoryName, classroomId, classroomName } = category;
    super({ id: `${classroomId}-${categoryId}`, header: classroomName, text: categoryName, data: category });
  }
}
